import { initEnv, inBiliApp, biliBridge } from '@bilibili/js-bridge'
import shareH5 from '@bilibili/share-h5-next'
initEnv()


function addUrlSuffix(msource: string, plat?: string) {
  return `?msource=${msource}${plat !== 'pc' ? '' : ''}`;
}

export function makeShareUrl(msource: string, plat?: string) {
  const currentUrl = location.href.split('?')[0]
  return currentUrl + addUrlSuffix(msource, plat)
}

export function downloadImage(base64Data: string, filename = 'image.png') {
  const link = document.createElement('a');
  link.href = base64Data;
  if (filename) {
    link.download = filename;
  }
  link.click();
}
 
export function getScoreProcessWidth (leftRatio: number, rightRatio: number, width: number, height: number, isPc: boolean) {
  const onlyLeft = rightRatio === 0;
  const onlyRight = leftRatio === 0;
  const singleSide = onlyLeft || onlyRight;
  const totalWidth = singleSide ? width : width - 10; // 两边进度条总宽度（去掉游标的宽度）
  const minWidth = singleSide ? 0 : isPc ? 45 : 65; // 单边进度条最小宽度
  const maxWidth = totalWidth - minWidth; // 单边进度条最大宽度
  const leftWidth = Math.min(
      Math.max((totalWidth * leftRatio) / 100, minWidth),
      maxWidth
  ); // 左边进度条宽度
  const rightWidth = totalWidth - leftWidth; // 右边进度条宽度
  // 处理斜切效果
  const radian = (10 * Math.PI) / 180; // 将角度转换为弧度
  const len = height * Math.sin(radian); // 计算直角短边的长度
  return {
    leftLongWidth: singleSide ? leftWidth : leftWidth + len,
    rightLongWidth: singleSide ? rightWidth : rightWidth + len,
    singleSide: singleSide
  }
}

function openScheme(scheme: string) {
  initEnv()
  const httpage = /(http|https):\/\//.test(scheme)
  biliBridge.callNative({
    method: 'ability.openScheme',
    data: {
      url: httpage ? `bilibili://browser?url=${encodeURIComponent(scheme)}` : scheme,
    },
  })
}

export function openUrl(url: string) {
  if (inBiliApp) {
    openScheme(url)
  } else {
    window.open(url, '_blank')
    // window.open(url)
  }
}
// schema的话，在安卓上（已安装app）直接跳一个空白页，然后弹出是否在 app 内打开（提供app 选项），打开后直接进入内部页面
export function openUrlH5(url: string) {
  if (inBiliApp) {
    openScheme(url)
  } else {
    window.open('bilibili://video/BV1pu4y1r7BF')// 未安装 app 的会弹出空白页，url 显示这个 schema（安卓）已安装 app 则会进入一个空白页，然后下方弹出打开 app
    // ios 会直接唤app 进入直播页（没有空白页）
    // window.open(url, '_blank')  
    // 去掉 blank 后和有blank 在 ios android 上表现一样，会打开一个空白页，ios 会直接进入 app 内。
  }
}

export function replaceHttp(url = '') {
  return url.replace(/http:/g, 'https:')
}

export function getScrollY() {
  const doc = document.documentElement
  return window.pageYOffset || doc.scrollTop || document.body.scrollTop || 0
}
export function sharePageH5() {
  // 进入页面调用一次即可 设置右上角...的分享
  shareH5.setContent({
    title: '英雄联盟S11',
    desc: '不破不立！英雄联盟S11征集活动进行中，百位人气UP陪你共同见证S11冠军的诞生！',
    link: 'https://www.bilibili.com/blackboard/activity-xWNrmunB1c.html', // 必传，请传一个可以访问的url
    pics: 'https://i0.hdslb.com/bfs/activity-plat/static/20210928/6a806a6a097a741ff3b5beac907646e3/oVGQECXbLK.png',
    // 非必填 动态预设文案
    edit_content: '哔哩哔哩携手百位人气UP共同助威英雄联盟S11~快来投稿&直播吧~',
  })
}

export function oneToWan(value: number) {
  const param = { value: 0, unit: '' }
  const k = 10000
  const sizes = [ '', '万', '亿', '万亿' ]
  let i
  let result
  if (value<k) {
    param.value = value
    param.unit = ''
  } else {
    i = Math.floor(Math.log(value)/Math.log(k))
    result = value/Math.pow(k, i)
    if (value%Math.pow(k, i)) param.value = Number(result.toFixed(1))
    else param.value = Number(result)
    param.unit = sizes[i]
  }
  if (param.unit === '万' && param.value > 1000) {
    param.value = Math.ceil(param.value)
  }
  return param.value + param.unit
}

export function secondToDate(seconds: number) {
  const h = Math.floor(seconds / 3600).toString().padStart(2, '0')
  const m = Math.floor((seconds / 60 % 60)).toString().padStart(2, '0')
  const s = Math.floor((seconds % 60)).toString().padStart(2, '0')
  if (h === '00') return `${m}:${s}`
  return `${h}:${m}:${s}`
}

export function formatTime(time: number) {
  const date = new Date(time*1000)
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return year + '-' + month + '-' + day 
}

export const getElementByAttr = (tag: string, dataAttr: string, val: string) => {
  const aElements = document.getElementsByTagName(tag)
  for (let i = 0; i < aElements.length; i++) {
    const value = aElements[i].getAttribute(dataAttr)
    if (val === value) {
      return aElements[i]
    }
  }
  return null
}

/**
 * @description: 判断dom元素是否在可视区域内
 * @param: el: Vuecomponnet对象
 * @returns: true-在可视区域，false: 不在可视区域
 */
export const isElementInViewport = (el: any, el2: any, otherHeight = 0) => {
  // if (!el) {
  //   return false
  // }
  const s = el.offsetTop + otherHeight// 元素相对于页面顶部的距离
  const x = el2.offsetHeight// 元素自身高度   
  const t = window.scrollY || window.pageYOffset || document.documentElement.scrollTop// 页面在垂直方向上滚动的距离
  const y = window.innerHeight// 窗口可视区域的高度
  // console.log(23333, el, s, x, t, y)
  if (t === 0 || x === 0) {
    return false
  }
  const isHidden = (s+x) < t || (s > (t+y))
  return !isHidden
};

/**
 * @description: 函数节流，即一定时间内，函数只能执行一次
 * @param: fn：要执行的函数
 * @param：wait：要间隔的时间差，（单位：毫秒）
 */
export const throttle = (fn: any, wait=500) => {
  let timer: any = null; // 定时器
  let firstTime = true;
  return function() {
    const args = Array.prototype.slice.call(arguments, 0);
    // 如果是第一次执行的话，需要立即执行该函数
    if (firstTime) {
      fn(args);
      firstTime = false;
    }
    // 如果当前有正在等待执行的函数则直接返回
    if (timer) return;
    // 开启一个倒计时定时器
    timer = setTimeout(function() {
      fn(args);
      // 清除之前的定时器
      timer = null;
    }, wait);
  };
}

export default {
  openUrl,
  replaceHttp,
  getScrollY,
}
